module.exports = __webpack_public_path__ + "static/media/ran_logo.586bc79e.svg";